import request from '@/utils/request'

/**
 * 拉取 MAP_DOMAIN 域下的全部配置（key/value 形式）。
 *
 * 走专用的 system.listMapConfig 接口，该接口对所有登录用户开放，
 * 不依赖「配置中心」菜单权限，避免普通业务账号无法读取地图 key 的问题。
 */
export function listMapConfig() {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.listMapConfig',
      method: 'get'
    })
      .then(response => {
        const res = response.data || {}
        if (res && res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
          resolve(res.data)
          return
        }
        // 兼容老结构：list of {key,value}
        const list = res.mappings || res.data || []
        const config = {}
        if (Array.isArray(list)) {
          list.forEach(item => {
            if (item && item.key) {
              config[item.key] = item.value
            }
          })
        }
        resolve(config)
      })
      .catch(reject)
  })
}
